import { api } from './client'

export async function listMergeFields() {
  const { data } = await api.get('/templates/merge-fields')
  return data
}

export async function listTemplates() {
  const { data } = await api.get('/templates')
  return data
}

export async function getTemplate(key) {
  const { data } = await api.get(`/templates/${key}`)
  return data
}

export async function createTemplate(body) {
  const { data } = await api.post('/templates', body)
  return data
}

export async function updateTemplate(key, body) {
  const { data } = await api.put(`/templates/${key}`, body)
  return data
}

export async function deleteTemplate(key) {
  await api.delete(`/templates/${key}`)
}

export async function resetTemplate(key) {
  const { data } = await api.post(`/templates/${key}/reset`)
  return data
}
